import {
  Component,
  inject,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  DropdownSimpleComponent,
  DropdownSize,
} from "@claas/claas-ui-components/dropdown";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "claas-product-family-year-select",
  imports: [TranslatePipe, DropdownSimpleComponent],
  templateUrl: "./product-family-year-select.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-family-year-select.scss",
})
export class ProductFamilyYearSelect {
  router = inject(Router);
  protected readonly dropdownSize = DropdownSize;

  @Input()
  options: number[] = [];

  @Input()
  defaultOption?: number;

  get optionsAsStrings(): string[] {
    return this.options.map(String);
  }

  get defaultOptionAsString(): string {
    return this.defaultOption?.toString() ?? "";
  }

  handleFilterSelectChange(yearSelected: string) {
    const url = this.router.url;

    // match everything up to product-info
    const match = url.match(/^(.*?\/)\d{4}\/product-info/);

    if (match) {
      const newUrl = `${match[1]}${yearSelected}/product-info`;
      this.router.navigateByUrl(newUrl);
    }
  }
}
